module.exports = __webpack_public_path__ + "img/ico_sick_select@2x.db993fcb.png";